import { render, staticRenderFns } from "./_Route.vue?vue&type=template&id=f21dc4f2&"
import script from "./_Route.vue?vue&type=script&lang=js&"
export * from "./_Route.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports